import { useState } from "react";


const useSearch = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [value, setValue] = useState<string>('');

    return {
        open,
        handleOpen: () => setOpen(true),
        handleClose: () => setOpen(false),
        value,
        handleChangeValue: (text: string) => setValue(text),
        reset: () => {
            setOpen(false);
            setValue('');
        }
    };
}

export default useSearch;